import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type { IApplyCodeParams, TApplyCodeResponse } from '../types/DiscountCode.types';
import { DISCOUNT_CODES_PATH } from './campaignApiBase';

/**
 * Apply a code to the current office (the office↔campaign opt-in). The office is
 * resolved from the JWT plus `x-office`, so the body carries only the code.
 *
 * Non-2xx responses carry `{ reason, message }` and are surfaced to the caller
 * as the raw AxiosError — the dialog maps `reason` to its four distinct states.
 */
export const applyCode = async ({ code }: IApplyCodeParams): Promise<TApplyCodeResponse> => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.post<TApplyCodeResponse>(
    DISCOUNT_CODES_PATH,
    { code },
    { headers },
  );

  return response.data;
};
